import React, {useState} from 'react'
import {createTax} from "../../services/serviceTax";
import {Button, Form, Input, Modal, InputNumber} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const {TextArea} = Input

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const TaxCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.taxName,
            code: list.taxCode,
            description: list.taxDescription,
            ratio: list.taxRatio
        }
        createTax(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Yeni Vergi Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            loading={loadings[0]}
                            onClick={() => form.submit()}
                    >Kaydet</Button>,
                    <Button  key={'CancelButton'} onClick={() => modalCloser()} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Vergi Adı'}
                        name={'taxName'}
                        rules={[
                            {required: true, message:'Vergi Adı Alanı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Vergi Adı Alanı En Az 5 En Fazla 300 Karakter Olmalıdır'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Vergi Kodu'}
                        name={'taxCode'}
                        rules={[
                            {required: true, message:'Vergi Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Vergi Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Vergi Kodu Alanı En Az 3 En Fazla 20 Karakter Olmalıdır'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Vergi Açıklaması'}
                        name={'taxDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Vergi Oranı'}
                        name={'taxRatio'}
                        rules={[
                            {required: true, message: 'Vergi Oranı Alanı Boş Bırakılamaz'},
                            {type: 'number', min: 1.00, max: 1000.00, message: 'Vergi Oranı En az 1 En Fazla 1000 Olabilir'}
                        ]}
                    >
                        <InputNumber  step={0.1}/>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default TaxCreate